import React from 'react';
import { Alert, Modal, Space, Tag, Tooltip, Typography, message } from 'antd';

const { Text } = Typography;

export const ok = (res) => res && (res.code === 0 || res.success === true);
export const errMsg = (e, fallback) => e?.error || e?.message || fallback;
/** apiClient 已对 4xx(除 404)/403/5xx/网络错误弹过提示；这里只补 404 或 quiet 请求 */
export const toastErr = (e, fallback, quiet = false) => {
    if (quiet || e?.status === 404) message.error(errMsg(e, fallback));
};
export const fmtTime = (s) => (s ? String(s).replace('T', ' ').slice(0, 19) : '-');
export const fmtNum = (n) => (n === null || n === undefined ? '-' : Number(n).toLocaleString());

const STREAM_STATUS = {
    active: ['green', '正常'], paused: ['orange', '已暂停'], suspended: ['default', '已停用'],
    banned: ['red', '已封禁'], terminated: ['default', '已释放'],
};
export const StreamStatusTag = ({ stream }) => {
    const [color, text] = STREAM_STATUS[stream.status] || ['default', stream.status];
    const reason = stream.status === 'banned' ? stream.banned_reason : stream.status === 'paused' ? stream.paused_reason : null;
    const tag = <Tag color={color} style={{ marginInlineEnd: 0 }}>{text}</Tag>;
    return reason ? <Tooltip title={reason}>{tag}</Tooltip> : tag;
};
export const STREAM_STATUS_OPTIONS = Object.keys(STREAM_STATUS).map((k) => ({ value: k, label: STREAM_STATUS[k][1] }));

export const TypeTag = ({ type }) => (type === 'marketing'
    ? <Tag color="purple" style={{ marginInlineEnd: 0 }}>营销</Tag>
    : <Tag color="blue" style={{ marginInlineEnd: 0 }}>交易</Tag>);

export const showSecretOnce = (title, secret, note) => {
    Modal.success({
        title,
        width: 600,
        okText: '我已保存',
        content: (
            <Space direction="vertical" style={{ width: '100%' }}>
                <Alert type="warning" showIcon message="只显示这一次" />
                <Text code copyable style={{ wordBreak: 'break-all' }}>{secret}</Text>
                {note ? <Text type="secondary">{note}</Text> : null}
            </Space>
        ),
    });
};
